/* eslint-disable import/no-default-export */
/* eslint-disable react/prop-types */
/* eslint-disable complexity */
import ProductSlider from 'components/ProductSlider'
import ProductAbout from './product-about'
import ProductDescriptionSection from './product-description-section'
import ProductGuides from './product-guides'
import ProductVideos from './product-videos'
import { ProductReviews } from '../product-reviews'
import { mapHeroesToProductCards } from '../product-grid'

const ProductContentSections = ({
  details,
  guides,
  videos,
  reviewSku,
  allReviewSkus,
  recommendedProducts,
}) => (
  <div>
    {details && (details.summary || details.highlight) ? (
      <ProductAbout about={details.summary} whatWeLove={details.highlight} />
    ) : null}
    {details && details.description ? (
      <ProductDescriptionSection
        title="Description"
        content={details.description}
      />
    ) : null}
    {details && details.specs ? (
      <ProductDescriptionSection title="Specs" content={details.specs} />
    ) : null}
    {videos && videos.length ? <ProductVideos videos={videos} /> : null}

    {recommendedProducts &&
      recommendedProducts.map((recommendation) => {
        return recommendation.products.length ? (
          <ProductSlider
            key={recommendation.title}
            products={recommendation.products.map((p) =>
              mapHeroesToProductCards(p)
            )}
            title={recommendation.title}
            trackingData={{
              productRecommenderModelVersion:
                recommendation.productRecommenderModelVersion,
            }}
          />
        ) : null
      })}

    <ProductReviews sku={reviewSku} productSkus={allReviewSkus} />

    {guides && guides.length ? (
      <ProductGuides guides={guides.slice(0, 3)} />
    ) : null}
  </div>
)

// eslint-disable-next-line import/no-default-export
export default ProductContentSections
